module.exports = __webpack_public_path__ + "static/media/forwardme.7ec6fca9.png";